export default {"src":"/_next/static/media/Returns&Refund.62f6ae73.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};